import React from 'react';
import { getBezierEdgeCenter, getBezierPath } from 'react-flow-renderer';
import { useSelector } from 'react-redux';
import { convertUserToContact } from '@debbie/common/dist/cases';
import { getContactPerson } from '@debbie/common/dist/customers';
import { fulfilRequirements } from '@debbie/common/dist/workflows';
import THEME from '../../theme';
import UserCheck from '../Icons/UserCheck';
import Badge from '../Badge';
const foreignObjectHeight = 50;
const foreignObjectWidth = 90;
const onEdgeClick = (evt, id) => { };
export default function CustomEdge({ id, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, style = {}, markerEnd, data, }) {
    var _a;
    const lang = useSelector((s) => s.lang);
    const edgePath = getBezierPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
    });
    const [edgeCenterX, edgeCenterY] = getBezierEdgeCenter({
        sourceX,
        sourceY,
        targetX,
        targetY,
    });
    const { timing, requirements, priority, manual, caseContext, warnings } = data;
    const timespan = (timing && timing.details && timing.details.timespan) || [];
    const isPossible = caseContext &&
        fulfilRequirements(requirements, {
            contact: convertUserToContact(getContactPerson(caseContext.customer)),
            updates: caseContext.updates,
            isCompany: caseContext.singleCase.isCompany,
            caseGroupId: ((_a = caseContext.singleCase.caseGroup) === null || _a === void 0 ? void 0 : _a.id) || null,
            caseId: caseContext.singleCase.caseId,
            caseVouchers: caseContext.caseVouchers,
            creditorId: caseContext.singleCase.creditorId,
            hasFoundation: caseContext.hasFoundation,
            foundationTypes: caseContext.foundationTypes,
            customerTags: caseContext.customer.tags,
            interactions: caseContext.interactions,
        });
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { id: id, style: style, className: "react-flow__edge-path", d: edgePath, markerEnd: markerEnd }),
        React.createElement("foreignObject", { width: foreignObjectWidth, height: foreignObjectHeight, x: edgeCenterX - foreignObjectWidth / 2, y: edgeCenterY - foreignObjectHeight / 5, requiredExtensions: "http://www.w3.org/1999/xhtml" },
            React.createElement("body", null,
                React.createElement("div", { style: {
                        background: THEME.COLOR_SECONDARY,
                        border: `2px solid ${THEME.COLOR_ACCENT}`,
                        borderRadius: '3px',
                        padding: '5px',
                        cursor: 'pointer',
                        fontSize: '10px',
                        lineHeight: 1,
                        textAlign: 'center',
                        userSelect: 'none',
                        opacity: !caseContext || isPossible ? 1 : 0.5,
                    }, onClick: (event) => onEdgeClick(event, id) },
                    React.createElement("div", { style: {
                            backgroundColor: THEME.COLOR_ACCENT,
                            display: 'inline-block',
                            padding: '0.4em',
                            borderRadius: '2px',
                            fontWeight: 'bold',
                            fontSize: '0.7em',
                            color: THEME.COLOR_SECONDARY,
                            marginRight: '5px',
                        } }, priority),
                    manual ? (React.createElement(UserCheck, { style: {
                            height: '13px',
                            margin: '-3px -3px -3px 3px',
                            width: '13px',
                        } })) : (React.createElement(React.Fragment, null,
                        React.createElement("b", null, timespan[0]),
                        ' ',
                        // @ts-ignore
                        lang.timespanUnits[timespan[1]])),
                    !!(warnings === null || warnings === void 0 ? void 0 : warnings.length) && (React.createElement(React.Fragment, null,
                        ' ',
                        React.createElement(Badge, { theme: THEME.WARNING }, "!"))))))));
}
//# sourceMappingURL=CustomEdge.js.map